import { Drawer } from '@design/components/drawer/Drawer';
import { FollowingConfiguration } from '@terminal/components/following-configuration/FollowingConfiguration';
import type { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useManageFollowingDrawer } from '@terminal/views/insight-feed/components/manage-following-drawer/useManageFollowingDrawer';
import type { ReactNode } from 'react';
import { useEffect } from 'react';

import styles from './BaseConfigurationDrawer.module.scss';

export interface BaseConfigurationDrawerProps {
  trackingSource: PosthogTrackingSource;
  activeDrawer: string;
  headerSection: ReactNode;
  testId?: string;
  showCompetitorsToggle?: boolean;
}

export const BaseConfigurationDrawer = ({
  trackingSource,
  activeDrawer,
  headerSection,
  testId,
  showCompetitorsToggle,
}: BaseConfigurationDrawerProps) => {
  const { isDrawerOpen, closeDrawer, activeTab, setActiveTab } =
    useManageFollowingDrawer(activeDrawer);
  const { trackFollowingDrawerOpen } = usePosthogEvents();

  useEffect(() => {
    if (isDrawerOpen) {
      trackFollowingDrawerOpen(trackingSource);
    }
  }, [isDrawerOpen, trackingSource]);

  return (
    <Drawer
      className={styles.drawer}
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      data-testid={testId}
    >
      <FollowingConfiguration
        activeTab={activeTab}
        headerSection={headerSection}
        onTabChange={setActiveTab}
        trackingSource={trackingSource}
        testId={testId}
        variant="drawer"
        showCompetitorsToggle={showCompetitorsToggle}
      />
    </Drawer>
  );
};
